<template>
  <div class="home">
    <a-row id="brand-intro">
      <h1><i>Firebound Soft</i></h1>
      <div id="brand-description">
        <p>
          We are an Indie studio trying to bring new and good histories, exploring different ways to 
          expose feelings and inmersion.
        </p>
        <p>
          We also love good all fun games, that's why we like creating small and fun games where your main goal is to disconnect and enjoy.
        </p>
      </div>
    </a-row>

    <a-row id="games-showcase">
      <h2>Our Games</h2>
      <GamesFeed/>
    </a-row>

    <a-row id="team-showcase">
      <h2>Meet our team</h2>

      <AboutPage/>
    </a-row>
  </div>
</template>

<script>
// @ is an alias to /src
import GamesFeed from '@/views/games/feed.vue'
import AboutPage from '@/views/About.vue'

export default {
  name: 'home',
  components: {
    GamesFeed,
    AboutPage
  }
}
</script>

<style scoped>
#brand-intro h1 {
  text-align: center;
  font-family: 'ZCOOL QingKe HuangYou', cursive;
  font-size: 45pt;
}

#brand-description {
  margin: 0 5em 0;
  text-align: center;
}

#games-showcase h2, #team-showcase h2 {
  margin-top: 1em;
  text-align: center;
  font-family: 'ZCOOL QingKe HuangYou', cursive;
  font-size: 40pt;
}

@media only screen and (min-width: 800px) {
  #brand-description {
    margin: 0 10em 0;
  }
}

@media only screen and (min-width: 1000px) {
  #brand-description {
    margin: 0 20em 0;
  }
}
</style>